import { FC } from 'react';
import { IUploadProps } from '../../types';
import UploadValidations from '../UploadValidations/UploadValidations';
import Button from 'src/view/components/Controls/ButtonComponent/Button';

type TProps = Pick<IUploadProps, 'smallValidationBlock' | 'maxFileSize' | 'allowedFileTypes'>;

interface IProps extends TProps {
  loading: boolean;
  error: string | null;
  filename?: string;
  image: string;
  timer: number;
  resetTimer: () => void;
  children?: React.ReactNode;
}

const UploadContents: FC<IProps> = (props: IProps): JSX.Element | null => {
  if (props.error) {
    return (
      <>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <UploadValidations {...props} />
        {props.timer ? (
          <div className="upload__button-container reset">
            <Button
              title={String(props.timer)}
              onClick={props.resetTimer}
              loading={props.loading}
              className="upload__button"
              titleClassName="text-size-18"
            />
          </div>
        ) : null}
      </>
    );
  }

  if (Boolean(props.filename || props.image)) return null;

  return <>{props.children}</> || null;
};

export default UploadContents;
